import { injectable, inject } from 'inversify';
import { NavigationEvent } from '@/app/statistics/events/navigation-events';
import { StoreCommandExecutor, createCommand, createQuery } from '@/app/tracking/common';
import { UpdateBookmarkTrackingCommand, QueryBookmarkTrackingQuery } from '../api';
import { Bookmark, defaultBookmark } from '../api';

@injectable()
export class BookmarkStateProjection {

  private currentSectionId: string | '' = '';
  private bookmark: Bookmark = defaultBookmark();
  private remoteFetched: boolean;

  constructor(
    @inject(StoreCommandExecutor)
    private readonly commandExecutor: StoreCommandExecutor) {
  }

  public async currentBookmark() {
    await this.prefetchBookmark();

    return this.bookmark;
  }

  public async handle(event: NavigationEvent) {
    switch (event.name) {
      case 'section-opened': {

        const sectionId = event.payload.sectionId;
        if (this.currentSectionId !== '') {
          console.error(`opening section '${sectionId}', but current section '${this.currentSectionId}' hasn't been closed`);
        }
        this.currentSectionId = sectionId;

        await this.prefetchBookmark();

        if (this.bookmark.sectionId !== sectionId) {
          this.bookmark = { sectionId } ;
          const command = createCommand<UpdateBookmarkTrackingCommand>('update-bookmark', {
            bookmark: { sectionId: sectionId }
          })
          this.commandExecutor.queue(command)
        }
        return true;
      }
      case 'section-closed': {
        const sectionId = event.payload.sectionId;

        if (this.currentSectionId !== sectionId) {
          console.error(`closing section '${sectionId}', but current section isn't the same, it is '${this.currentSectionId}'`);
        }
        this.currentSectionId = '';

        return true;
      }
    }

    return false;
  }

  private async prefetchBookmark(): Promise<false | 'fetched' | 'already-fetched'> {
    if (this.remoteFetched) {
      return 'already-fetched';
    }

    const query = createQuery<QueryBookmarkTrackingQuery>('query-bookmark', {})
    const result = await this.commandExecutor.query(query)
    
    this.remoteFetched = true;
    this.bookmark = result.bookmark;
    return 'fetched';
  }
}
